import * as Preact from 'preact';
import { Box, Typography } from '@mui/material';
import * as Button from './A_Button';
export var Component = function (p) {
    return (Preact.h(Box, { paddingBottom: "10px", boxSizing: "border-box", width: "100%", height: "201px", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", borderRadius: "10px", bgcolor: "background.default" },
        Preact.h(Typography, { variant: "h6", padding: "10px" }, p.title),
        Preact.h(Typography, { variant: "body2", color: "secondary", textAlign: "center", padding: "8px 24px 24px 24px" }, p.message),
        Preact.h(Button.Component, { endIcon: p.actionIcon, variant: "contained", size: "medium", onClick: p.onActionClick, padding: "5px" }, p.actionText)));
};
Component.displayName = 'MessageWithAction';
